module.exports = {
  currentSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/miniProgram/i.test(userAgent)) {
      return "miniprogram";
    }
    if (/micromessenger/i.test(userAgent)) {
      return "Wechat";
    }
    if (/android/i.test(userAgent)) {
      return "Android";
    }
    if (/iPad|iPhone|iPod|iOS/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }
    return "Unknown";
  },
  currentPlatform() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      return "Android";
    }
    if (/iPad|iPhone|iPod|iOS/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }
    return "Unknown";
  }
}



// WEBPACK FOOTER //
// ./src/libs/system.js